export const apiConfig = {
  coreApiBaseUrl: process.env.REACT_APP_CORE_API,
  hashApiBaseUrl: process.env.REACT_APP_HASH_API
};

export const RECAPTCHA_KEY = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_RECAPTCHA_KEY_DEV
  : process.env.REACT_APP_RECAPTCHA_KEY;